import { render, staticRenderFns } from "./newsContent.vue?vue&type=template&id=49a31a6f&scoped=true"
import script from "./newsContent.vue?vue&type=script&lang=js"
export * from "./newsContent.vue?vue&type=script&lang=js"
import style0 from "./newsContent.vue?vue&type=style&index=0&id=49a31a6f&prod&lang=less&scoped=true"
import style1 from "./newsContent.vue?vue&type=style&index=1&id=49a31a6f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a31a6f",
  null
  
)

export default component.exports